import { SchoolManager } from './schoolManager';

export const mySchoolManager = {
  template: require('./schoolManager.html'),
  controllerAs: 'ctrl',
  controller: SchoolManager,
};
